import Header from "./header";

interface WorkbenchLayoutProps {
  children: React.ReactNode;
}

// Layout for the admin-only Sponsor Workbench ("new experience"). Reuses the
// shared Header (which carries the experience toggle) with a single centered
// content column; no classic sidebar.
export default function WorkbenchLayout({ children }: WorkbenchLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
